/* unplugin-vue-components disabled */import { render } from "./FormSms.vue?vue&type=template&id=705e687a&ts=true"
import script from "./FormSms.vue?vue&type=script&lang=ts"
export * from "./FormSms.vue?vue&type=script&lang=ts"

import "./FormSms.vue?vue&type=style&index=0&id=705e687a&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__